// extracted by mini-css-extract-plugin
module.exports = {"image":"BlurrImage__image"};